var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttentionGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 2.50053H10.35C10 1.53386 9.08333 0.833862 8 0.833862C6.91667 0.833862 6 1.53386 5.65 2.50053H2.16667C1.25 2.50053 0.5 3.25053 0.5 4.1672V15.8339C0.5 16.7505 1.25 17.5005 2.16667 17.5005H13.8333C14.75 17.5005 15.5 16.7505 15.5 15.8339V4.1672C15.5 3.25053 14.75 2.50053 13.8333 2.50053ZM8.83333 15.0005H7.16667V13.3339H8.83333V15.0005ZM8.83333 11.6672H7.16667V6.6672H8.83333V11.6672ZM8 4.1672C7.54167 4.1672 7.16667 3.7922 7.16667 3.33386C7.16667 2.87553 7.54167 2.50053 8 2.50053C8.45833 2.50053 8.83333 2.87553 8.83333 3.33386C8.83333 3.7922 8.45833 4.1672 8 4.1672Z",
    fill: "#2DB875"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionGreenIcon);
export default __webpack_public_path__ + "static/media/attention-green_icon.689cd9344280a54eff3e8c5d6255c29e.svg";
export { ForwardRef as ReactComponent };